<div class="error-page">
    <h1>404</h1>
    <p>Page not found</p>
    <a routerLink="/admission/student-form">Go Home</a>
  </div>
